/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsaddtype2Inputs */

const en_ticketsaddtype2 = /** @type {(inputs: Ticketsaddtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add ticket type`)
};

const de_ticketsaddtype2 = /** @type {(inputs: Ticketsaddtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketart hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add ticket type" |
*
* @param {Ticketsaddtype2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsaddtype2 = /** @type {((inputs?: Ticketsaddtype2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsaddtype2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsaddtype2(inputs)
	return de_ticketsaddtype2(inputs)
});
export { ticketsaddtype2 as "ticketsAddType" }